module.exports = __webpack_public_path__ + "static/media/world.9a809ece.svg";